import { CommonModule } from '@angular/common';
import { AfterContentInit, Component, ElementRef, HostBinding, Input, ViewChild, inject } from '@angular/core';
import { Params } from '@angular/router';
import { LinkLabelComponent } from '../labels/link-label.component';

@Component({
  selector: 'app-back-button',
  imports: [CommonModule, LinkLabelComponent],
  template: `<app-link-label
    classes="tw-vertical-align tw-flex tw-items-center tw-grow-0 back-button-link"
    [routerLink]="routerLink"
    [queryParams]="queryParams"
    [ariaLabel]="buttonAriaLabel"
    (click)="onInnerClick($event)"
    ><i
      class="fa-light fa-arrow-left tw-text-[18px] tw-pr-2"
      aria-hidden="true"
    ></i
    ><span #labelContent><ng-content></ng-content></span
  ></app-link-label>`,
  styles: `
    .back-button-link:focus {
      outline: 2px solid var(--sed-engaged-black-color);
      outline-offset: 2px;
      text-decoration-line: underline;
      text-decoration-style: solid;
      text-underline-offset: var(--link-underline-offset);
      text-decoration-thickness: var(--link-underline-thickness-hover);
    }
  `,
})
export class BackButtonComponent implements AfterContentInit {
  private elementRef = inject(ElementRef);

  @HostBinding('attr.tabindex')
  hostTabindex: number | null = null;

  @ViewChild('labelContent', { static: true })
  labelContent: ElementRef;

  @Input()
  routerLink: string;

  @Input()
  queryParams: Params | null = null;

  @Input()
  ariaLabel: string;

  buttonAriaLabel = 'Go back';

  ngAfterContentInit() {
    const textContent = this.labelContent?.nativeElement?.textContent?.trim();
    if (this.ariaLabel) {
      this.buttonAriaLabel = this.ariaLabel;
    } else if (textContent) {
      this.buttonAriaLabel = textContent;
    }
  }

  onInnerClick(event: Event) {
    this.elementRef.nativeElement.dispatchEvent(
      new MouseEvent('click', { bubbles: true }),
    );
  }
}
